import React from 'react';
import { Button } from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import manualePDF from '../assets/manuale.pdf';

const DownloadPDFButton = () => {
  return (
    <Button
      variant="outlined"
      style={{
        backgroundColor: 'transparent',  // Sfondo trasparente
        color: '#9e9e9e',  // Scritta grigia
        borderColor: '#9e9e9e',  // Colore del bordo grigio
      }}
      component="a"
      href={manualePDF}
      download="manuale.pdf"
      startIcon={<MenuBookIcon />}  // Aggiunge l'icona al inizio del bottone
    >
      Manuale
    </Button>
  );
};

export default DownloadPDFButton;
